// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateTileNotesSubscriptionVariables = Types.Exact<{
  input: Array<Types.TileNotesInput> | Types.TileNotesInput;
  prompt: Types.Scalars['String']['input'];
  matchSummaryFormats?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GenerateTileNotesSubscription = { __typename?: 'Subscription', generateTileNotes: { __typename?: 'TileNotesResult', tileID: string, notes?: string | null, isComplete: boolean, error?: string | null } };

export const Operations = {
  Subscription: {
    GenerateTileNotes: 'GenerateTileNotes' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GenerateTileNotesDocument = gql`
    subscription GenerateTileNotes($input: [TileNotesInput!]!, $prompt: String!, $matchSummaryFormats: Boolean) {
  generateTileNotes(
    input: $input
    prompt: $prompt
    matchSummaryFormats: $matchSummaryFormats
  ) {
    tileID
    notes
    isComplete
    error
  }
}
    `;

/**
 * __useGenerateTileNotesSubscription__
 *
 * To run a query within a React component, call `useGenerateTileNotesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGenerateTileNotesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateTileNotesSubscription({
 *   variables: {
 *      input: // value for 'input'
 *      prompt: // value for 'prompt'
 *      matchSummaryFormats: // value for 'matchSummaryFormats'
 *   },
 * });
 */
export function useGenerateTileNotesSubscription(baseOptions: Apollo.SubscriptionHookOptions<GenerateTileNotesSubscription, GenerateTileNotesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GenerateTileNotesSubscription, GenerateTileNotesSubscriptionVariables>(GenerateTileNotesDocument, withSubscriptionIgnoreResults(options));
      }
export type GenerateTileNotesSubscriptionHookResult = ReturnType<typeof useGenerateTileNotesSubscription>;
export type GenerateTileNotesSubscriptionResult = Apollo.SubscriptionResult<GenerateTileNotesSubscription>;